// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableQuotationRecordsStyle\n{\n    overflow: auto;\n    height: 67vh;\n}\n\n.tdtableProductStyleQuotationrecord\n  {\n    max-width: 200px;\n    word-wrap: break-word;\n  }\n\n  table thead th\n  {\n    position: sticky;\n    position: -webkit-sticky;\n    top:-2px;\n    z-index:100;\n  }\n\n  .modal\n  {\n    z-index: 1001;\n  }\n\n  .react-confirm-alert-overlay\n  {\n    z-index: 1001;\n    background-color: rgba(0,0,0,0.4);\n  }", ""]);
// Exports
module.exports = exports;
